<template>
  <div>
    <b-notification
      v-if="exibirAvisoPreclusaoConsumativa"
      type="is-warning"
      :closable="false"
      class="recurso-aviso"
    >
      <b-icon icon="information-outline" size="is-small" class="mr-1" />
      Como você excluiu o seu recurso, não é possível enviá-lo novamente devido à preclusão
      consumativa.
    </b-notification>

    <b-notification
      v-if="exibirAvisoSemIntencao"
      type="is-info"
      :closable="false"
      class="recurso-aviso"
    >
      <b-icon icon="information-outline" size="is-small" class="mr-1" />
      Apenas licitantes que manifestaram intenção podem enviar recursos.
    </b-notification>

    <b-notification
      v-if="exibirAvisoAguardandoAberturaPrazos"
      type="is-info"
      :closable="false"
      class="recurso-aviso"
    >
      <b-icon icon="information-outline" size="is-small" class="mr-1" />
      Aguarde a abertura do prazo para manifestação de recursos (envio das razões)
    </b-notification>

    <div>
      <div v-if="!exibirTabela && !podeApresentarRazoesForm" class="panel">
        <div class="panel-block div-paragraph">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>Nenhum recurso</p>
            </div>
          </section>
        </div>
      </div>

      <b-table
        v-if="exibirTabela"
        class="manifestacao-listagem"
        hoverable
        striped
        detailed
        detail-key="id"
        :data="recursos"
        :opened-detailed.sync="defaultOpenedDetails"
        :row-class="classeLinhaManifestacao"
      >
        <b-table-column centered numeric field="id" label="Nro" width="80" v-slot="props">
          {{ String(props.row.id).padStart(2, '0') }}
        </b-table-column>

        <b-table-column field="empresa" label="Empresa" v-slot="props">
          {{ nomeEmpresaRecurso(props.row) }}
        </b-table-column>

        <b-table-column field="assunto" label="Assunto" v-slot="props">
          <span>{{ props.row.assunto }}</span>
        </b-table-column>

        <b-table-column centered field="status" label="Situação" width="169" v-slot="props">
          <ManifestacaoSituacaoBadge
            :status="props.row.status"
            :para-licitante="!company.buyer"
            :manifestacao="props.row"
            :company="company"
            fluxo="recurso"
            :janela-recursal="janelaRecursalVigente"
            :papel="papelRecurso"
          />
        </b-table-column>

        <template v-slot:detail="props">
          <article v-if="recursoEmEdicao(props.row.id)" class="media">
            <div class="media-content">
              <div
                class="recurso-form-titulo"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 100%;
                "
              >
                <h2 class="title is-5" style="margin-bottom: 0; width: auto; flex: 1 1 auto">
                  Editar Recurso
                </h2>
                <FeatureTourHelp
                  class="recurso-form-tour-help"
                  style="flex: 0 0 auto; margin-left: 0.75rem"
                  :icon-only="true"
                  label=""
                  icon="help-circle"
                  icon-size="is-medium"
                  trigger-class="has-text-link"
                  contexto="auction.recursos"
                  :feature-ctx="ctxTourRecursos()"
                  scope="acoes-editar-excluir"
                  @selecionar="reabrirTutorialRecurso"
                />
              </div>
              <form @submit.prevent="confirmarEdicaoRecurso(props.row)">
                <ManifestacaoFormLayout>
                  <b-field grouped class="column-direction-touch">
                    <b-field expanded label="Nome">
                      <b-input :disabled="logged" :value="obterEdicaoCampo(props.row.id, 'nome')" />
                    </b-field>
                    <b-field v-if="logged" label="CNPJ">
                      <b-input :disabled="logged" :value="obterEdicaoCampo(props.row.id, 'cnpj')" />
                    </b-field>
                    <b-field expanded label="E-mail">
                      <b-input
                        :disabled="logged"
                        :value="obterEdicaoCampo(props.row.id, 'email')"
                      />
                    </b-field>
                  </b-field>
                  <b-field grouped class="column-direction-touch">
                    <b-field
                      expanded
                      label="Assunto"
                      :type="edicaoInvalida(props.row.id, 'assunto') ? 'is-danger' : ''"
                      :message="
                        edicaoInvalida(props.row.id, 'assunto')
                          ? 'Assunto é um campo obrigatório'
                          : ''
                      "
                    >
                      <b-input
                        custom-class="uppercase"
                        :value="obterEdicaoCampo(props.row.id, 'assunto')"
                        @input="valor => definirEdicaoCampo(props.row.id, 'assunto', valor)"
                      />
                    </b-field>
                  </b-field>
                  <b-field
                    class="manifestacao-campo-textarea"
                    label="Razões"
                    :type="edicaoInvalida(props.row.id, 'mensagem') ? 'is-danger' : ''"
                    :message="
                      edicaoInvalida(props.row.id, 'mensagem')
                        ? 'Informe as razões para confirmar as alterações'
                        : ''
                    "
                  >
                    <b-input
                      type="textarea"
                      :value="obterEdicaoCampo(props.row.id, 'mensagem')"
                      @input="valor => definirEdicaoCampo(props.row.id, 'mensagem', valor)"
                    />
                  </b-field>
                  <template #upload>
                    <AppUploadPanel
                      class="column manifestacao-form-upload"
                      :value="arquivosEdicao[props.row.id] || []"
                      :anexos-salvos="anexosSalvosEdicao[props.row.id] || []"
                      @update:anexosSalvos="valor => definirAnexosSalvosEdicao(props.row.id, valor)"
                      @input="valor => definirArquivosEdicao(props.row.id, valor)"
                    />
                  </template>
                  <template #actions>
                    <div class="manifestacao-form-botoes">
                      <button
                        type="submit"
                        class="button is-primary send-button"
                        :class="{ ' is-loading': !!loadingEdicao[props.row.id] }"
                      >
                        Confirmar
                      </button>
                      <button
                        type="button"
                        class="button send-button"
                        :disabled="!!loadingEdicao[props.row.id]"
                        @click.prevent="cancelarEdicaoRecurso(props.row.id)"
                      >
                        Cancelar
                      </button>
                    </div>
                  </template>
                </ManifestacaoFormLayout>
              </form>
            </div>
          </article>

          <template v-else>
            <template v-for="(manifestacao, indice) in props.row.manifestacoes">
              <hr
                v-if="indice > 0"
                :key="`manifestacao-sep-${manifestacao.id}`"
                class="manifestacao-separador"
              />
              <div
                :key="`manifestacao-corpo-${manifestacao.id}`"
                class="manifestacao-recurso-corpo"
              >
                <article v-if="contrarrazaoEmEdicao(manifestacao.id)" class="media">
                  <div class="media-content">
                    <div
                      class="recurso-form-titulo"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <h2 class="title is-5" style="margin-bottom: 0; width: auto; flex: 1 1 auto">
                        Editar contrarrazões
                      </h2>
                      <FeatureTourHelp
                        class="recurso-form-tour-help"
                        style="flex: 0 0 auto; margin-left: 0.75rem"
                        :icon-only="true"
                        label=""
                        icon="help-circle"
                        icon-size="is-medium"
                        trigger-class="has-text-link"
                        contexto="auction.recursos"
                        :feature-ctx="ctxTourRecursos()"
                        scope="acoes-editar-excluir"
                        @selecionar="reabrirTutorialRecurso"
                      />
                    </div>
                    <form @submit.prevent="confirmarEdicaoContrarrazao(props.row, manifestacao)">
                      <ManifestacaoFormLayout>
                        <b-field grouped class="column-direction-touch">
                          <b-field expanded label="Nome">
                            <b-input
                              :disabled="logged"
                              :value="obterEdicaoContrarrazaoCampo(manifestacao.id, 'nome')"
                            />
                          </b-field>
                          <b-field v-if="logged" label="CNPJ">
                            <b-input
                              :disabled="logged"
                              :value="obterEdicaoContrarrazaoCampo(manifestacao.id, 'cnpj')"
                            />
                          </b-field>
                          <b-field expanded label="E-mail">
                            <b-input
                              :disabled="logged"
                              :value="obterEdicaoContrarrazaoCampo(manifestacao.id, 'email')"
                            />
                          </b-field>
                        </b-field>
                        <b-field
                          class="manifestacao-campo-textarea"
                          label="Contrarrazões"
                          :type="
                            edicaoContrarrazaoInvalida(manifestacao.id, 'mensagem')
                              ? 'is-danger'
                              : ''
                          "
                          :message="
                            edicaoContrarrazaoInvalida(manifestacao.id, 'mensagem')
                              ? 'Informe as contrarrazões para confirmar as alterações'
                              : ''
                          "
                        >
                          <b-input
                            maxlength="1000"
                            type="textarea"
                            :value="obterEdicaoContrarrazaoCampo(manifestacao.id, 'mensagem')"
                            @input="
                              valor =>
                                definirEdicaoContrarrazaoCampo(manifestacao.id, 'mensagem', valor)
                            "
                          />
                        </b-field>
                        <template #upload>
                          <AppUploadPanel
                            class="column manifestacao-form-upload"
                            :value="arquivosEdicaoContrarrazao[manifestacao.id] || []"
                            :anexos-salvos="anexosSalvosEdicaoContrarrazao[manifestacao.id] || []"
                            @update:anexosSalvos="
                              valor => definirAnexosSalvosEdicaoContrarrazao(manifestacao.id, valor)
                            "
                            @input="
                              valor => definirArquivosEdicaoContrarrazao(manifestacao.id, valor)
                            "
                          />
                        </template>
                        <template #actions>
                          <div class="manifestacao-form-botoes">
                            <button
                              type="submit"
                              class="button is-primary send-button"
                              :class="{
                                ' is-loading': !!loadingEdicaoContrarrazao[manifestacao.id],
                              }"
                            >
                              Confirmar
                            </button>
                            <button
                              type="button"
                              class="button send-button"
                              :disabled="!!loadingEdicaoContrarrazao[manifestacao.id]"
                              @click.prevent="cancelarEdicaoContrarrazao(manifestacao.id)"
                            >
                              Cancelar
                            </button>
                          </div>
                        </template>
                      </ManifestacaoFormLayout>
                    </form>
                  </div>
                </article>
                <AppMensagem
                  v-else
                  :nome="
                    exibirNomeRemetenteManifestacao(manifestacao.tipo)
                      ? manifestacao.nome
                      : undefined
                  "
                  :email="manifestacao.email"
                  :data="manifestacao.criado"
                  :editada-em="obterDataEdicaoManifestacao(manifestacao)"
                  nome-apos-email
                >
                  <template #rotulo>
                    <b-tag class="manifestacao-chip mr-2" type="is-light" rounded>
                      {{ chipManifestacao(manifestacao.tipo) }}
                    </b-tag>
                  </template>
                  <template #acoes>
                    <div
                      v-if="
                        podeExibirEditarManifestacao(props.row, manifestacao) ||
                        podeExibirExcluirManifestacao(props.row, manifestacao)
                      "
                      data-tour="recursos-acoes-editar-excluir"
                      class="buttons has-addons recurso-acoes"
                    >
                      <button
                        v-if="podeExibirEditarManifestacao(props.row, manifestacao)"
                        type="button"
                        data-tour="recursos-editar-manifestacao"
                        class="button is-primary is-small recurso-acao-btn"
                        title="Editar recurso"
                        @click.prevent.stop="iniciarEdicaoRecurso(props.row)"
                      >
                        <b-icon icon="pencil" size="is-small" />
                      </button>
                      <button
                        v-if="podeExibirExcluirManifestacao(props.row, manifestacao)"
                        type="button"
                        data-tour="recursos-excluir-manifestacao"
                        class="button is-danger is-small recurso-acao-btn"
                        title="Excluir recurso"
                        :class="{ ' is-loading': !!loadingExclusao[props.row.id] }"
                        @click.prevent.stop="confirmarExclusaoRazoes(props.row)"
                      >
                        <b-icon icon="delete" size="is-small" />
                      </button>
                    </div>
                    <div
                      v-if="
                        podeExibirEditarContrarrazao(props.row, manifestacao) ||
                        podeExibirExcluirContrarrazao(props.row, manifestacao)
                      "
                      data-tour="recursos-acoes-editar-excluir"
                      class="buttons has-addons recurso-acoes"
                    >
                      <button
                        v-if="podeExibirEditarContrarrazao(props.row, manifestacao)"
                        type="button"
                        data-tour="recursos-editar-manifestacao"
                        class="button is-primary is-small recurso-acao-btn"
                        title="Editar contrarrazões"
                        @click.prevent.stop="iniciarEdicaoContrarrazao(props.row, manifestacao)"
                      >
                        <b-icon icon="pencil" size="is-small" />
                      </button>
                      <button
                        v-if="podeExibirExcluirContrarrazao(props.row, manifestacao)"
                        type="button"
                        data-tour="recursos-excluir-manifestacao"
                        class="button is-danger is-small recurso-acao-btn"
                        title="Excluir contrarrazões"
                        :class="{
                          ' is-loading': !!loadingExclusaoContrarrazao[manifestacao.id],
                        }"
                        @click.prevent.stop="confirmarExclusaoContrarrazao(props.row, manifestacao)"
                      >
                        <b-icon icon="delete" size="is-small" />
                      </button>
                    </div>
                  </template>
                  <template #prefix>
                    <ManifestacaoAnexosLista :anexos="manifestacao.anexos" />
                  </template>
                  <ManifestacaoMensagemTexto
                    :texto="manifestacao.descricao"
                    conteudo-classe="content mensagem"
                  />
                </AppMensagem>
              </div>
            </template>

            <hr
              v-if="exibirCamposConsideracao(props.row) && props.row.manifestacoes.length"
              class="manifestacao-separador"
            />

            <article
              class="media"
              v-if="exibirCamposConsideracao(props.row)"
              data-tour="recursos-form-consideracao"
            >
              <div class="media-content">
                <div
                  class="recurso-form-titulo"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <h2
                    class="title is-5 titulo-julgamento"
                    style="margin-bottom: 0; width: auto; flex: 1 1 auto"
                  >
                    Juizo de Consideração
                  </h2>
                  <FeatureTourHelp
                    class="recurso-form-tour-help"
                    style="flex: 0 0 auto; margin-left: 0.75rem"
                    :icon-only="true"
                    label=""
                    icon="help-circle"
                    icon-size="is-medium"
                    trigger-class="has-text-link"
                    contexto="auction.recursos"
                    :feature-ctx="ctxTourRecursos()"
                    scope="form-consideracao"
                    @selecionar="reabrirTutorialRecurso"
                  />
                </div>
                <ManifestacaoFormLayout class="manifestacao-resposta-form">
                  <b-field
                    data-tour="recursos-form-consideracao-desfecho"
                    label="Consideração"
                    :type="campoInvalido('desfecho', 'resposta') ? 'is-danger' : ''"
                    :message="
                      campoInvalido('desfecho', 'resposta')
                        ? 'Consideração é um campo obrigatório'
                        : ''
                    "
                  >
                    <b-select
                      v-model="$v.resposta.desfecho.$model[props.index]"
                      @click.native="$v.resposta.desfecho.$touch()"
                    >
                      <option v-for="status in opcoesStatus" :key="status.id" :value="status.id">
                        {{ status.nome }}
                      </option>
                    </b-select>
                  </b-field>

                  <b-field
                    data-tour="recursos-form-consideracao-fundamentacao"
                    class="manifestacao-campo-textarea"
                    label="Fundamentação da Consideração"
                    :type="campoInvalido('justificativa', 'resposta') ? 'is-danger' : ''"
                    :message="
                      campoInvalido('justificativa', 'resposta')
                        ? 'Informe a fundamentação para a Consideração do recurso'
                        : ''
                    "
                  >
                    <b-input
                      maxlength="1000"
                      type="textarea"
                      v-model="$v.resposta.justificativa.$model[props.index]"
                    />
                  </b-field>
                  <template #upload>
                    <AppUploadPanel
                      data-tour="recursos-form-consideracao-upload"
                      class="column manifestacao-form-upload"
                      :value="arquivosResposta[props.row.id] || []"
                      @input="valor => definirArquivosResposta(props.row.id, valor)"
                    />
                  </template>
                  <template #actions>
                    <button
                      type="button"
                      data-tour="recursos-enviar-consideracao"
                      class="button is-primary send-button"
                      :class="{ ' is-loading': !!loadingResposta[props.row.id] }"
                      @click.prevent.stop="salvarJustificativa(props.row, props.index)"
                    >
                      Enviar Consideração
                    </button>
                  </template>
                </ManifestacaoFormLayout>
              </div>
            </article>

            <hr
              v-if="podeContrarrazoar(props.row) && props.row.manifestacoes.length"
              class="manifestacao-separador"
            />

            <article
              class="media"
              v-if="podeContrarrazoar(props.row)"
              data-tour="recursos-form-contrarrazoes"
            >
              <div class="media-content">
                <div
                  class="recurso-form-titulo"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <h2
                    class="title is-5 titulo-contrarrazao"
                    style="margin-bottom: 0; width: auto; flex: 1 1 auto"
                  >
                    Apresentar contrarrazões
                  </h2>
                  <FeatureTourHelp
                    class="recurso-form-tour-help"
                    style="flex: 0 0 auto; margin-left: 0.75rem"
                    :icon-only="true"
                    label=""
                    icon="help-circle"
                    icon-size="is-medium"
                    trigger-class="has-text-link"
                    contexto="auction.recursos"
                    :feature-ctx="ctxTourRecursos()"
                    scope="form-contrarrazoes"
                    @selecionar="reabrirTutorialRecurso"
                  />
                </div>
                <ManifestacaoFormLayout class="manifestacao-resposta-form">
                  <b-field
                    data-tour="recursos-form-contrarrazoes-mensagem"
                    class="manifestacao-campo-textarea"
                    label="Contrarrazões"
                    :type="contrarrazaoInvalida(props.row.id) ? 'is-danger' : ''"
                    :message="
                      contrarrazaoInvalida(props.row.id)
                        ? 'Informe as contrarrazões para enviá-las'
                        : ''
                    "
                  >
                    <b-input
                      maxlength="1000"
                      type="textarea"
                      :value="obterContrarrazaoTexto(props.row.id)"
                      @input="valor => definirContrarrazaoTexto(props.row.id, valor)"
                    />
                  </b-field>
                  <template #upload>
                    <AppUploadPanel
                      data-tour="recursos-form-contrarrazoes-upload"
                      class="column manifestacao-form-upload"
                      :value="arquivosContrarrazao[props.row.id] || []"
                      @input="valor => definirArquivosContrarrazao(props.row.id, valor)"
                    />
                  </template>
                  <template #actions>
                    <button
                      type="button"
                      data-tour="recursos-enviar-contrarrazoes"
                      class="button is-primary send-button"
                      :class="{ ' is-loading': !!loadingContrarrazao[props.row.id] }"
                      @click.prevent.stop="salvarContrarrazaoRecurso(props.row)"
                    >
                      Enviar Contrarrazões
                    </button>
                  </template>
                </ManifestacaoFormLayout>
              </div>
            </article>

            <hr
              v-if="exibirJulgamentoAutoridade(props.row) && props.row.manifestacoes.length"
              class="manifestacao-separador"
            />

            <article
              class="media"
              v-if="exibirJulgamentoAutoridade(props.row)"
              data-tour="recursos-form-julgamento"
            >
              <div class="media-content">
                <div
                  class="recurso-form-titulo"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <h2
                    class="title is-5 titulo-julgamento"
                    style="margin-bottom: 0; width: auto; flex: 1 1 auto"
                  >
                    Julgamento da autoridade
                  </h2>
                  <FeatureTourHelp
                    class="recurso-form-tour-help"
                    style="flex: 0 0 auto; margin-left: 0.75rem"
                    :icon-only="true"
                    label=""
                    icon="help-circle"
                    icon-size="is-medium"
                    trigger-class="has-text-link"
                    contexto="auction.recursos"
                    :feature-ctx="ctxTourRecursos()"
                    scope="form-julgamento"
                    @selecionar="reabrirTutorialRecurso"
                  />
                </div>
                <ManifestacaoFormLayout class="manifestacao-resposta-form">
                  <b-field
                    data-tour="recursos-form-julgamento-desfecho"
                    label="Desfecho"
                    :type="campoInvalido('desfecho', 'julgamentoAutoridade') ? 'is-danger' : ''"
                    :message="
                      campoInvalido('desfecho', 'julgamentoAutoridade')
                        ? 'Desfecho é um campo obrigatório'
                        : ''
                    "
                  >
                    <b-select
                      v-model="$v.julgamentoAutoridade.desfecho.$model[props.index]"
                      @click.native="$v.julgamentoAutoridade.desfecho.$touch()"
                    >
                      <option
                        v-for="opcao in opcoesJulgamentoAutoridade"
                        :key="opcao.id"
                        :value="opcao.id"
                      >
                        {{ opcao.nome }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field
                    data-tour="recursos-form-julgamento-fundamentacao"
                    class="manifestacao-campo-textarea"
                    label="Fundamentação do julgamento"
                    :type="
                      campoInvalido('justificativa', 'julgamentoAutoridade') ? 'is-danger' : ''
                    "
                    :message="
                      campoInvalido('justificativa', 'julgamentoAutoridade')
                        ? 'Informe a fundamentação para julgar o recurso'
                        : ''
                    "
                  >
                    <b-input
                      maxlength="1000"
                      type="textarea"
                      v-model="$v.julgamentoAutoridade.justificativa.$model[props.index]"
                    />
                  </b-field>
                  <template #upload>
                    <AppUploadPanel
                      data-tour="recursos-form-julgamento-upload"
                      class="column manifestacao-form-upload"
                      :value="arquivosJulgamentoAutoridade[props.row.id] || []"
                      @input="valor => definirArquivosJulgamentoAutoridade(props.row.id, valor)"
                    />
                  </template>
                  <template #actions>
                    <button
                      type="button"
                      data-tour="recursos-enviar-julgamento"
                      class="button is-primary send-button"
                      :class="{ ' is-loading': !!loadingJulgamentoAutoridade[props.row.id] }"
                      @click.prevent.stop="salvarJulgamentoAutoridade(props.row, props.index)"
                    >
                      Enviar Julgamento
                    </button>
                  </template>
                </ManifestacaoFormLayout>
              </div>
            </article>
          </template>
        </template>
      </b-table>
    </div>

    <div class="send-resource" v-if="podeApresentarRazoesForm" data-tour="recursos-form-razoes">
      <div
        class="recurso-form-titulo titulo-form"
        style="display: flex; align-items: center; justify-content: space-between; width: 100%"
      >
        <h1
          v-if="licitante"
          class="title is-4"
          style="margin-bottom: 0; width: auto; flex: 1 1 auto"
        >
          Enviar Recurso
        </h1>
        <FeatureTourHelp
          class="recurso-form-tour-help"
          style="flex: 0 0 auto; margin-left: 0.75rem"
          :icon-only="true"
          label=""
          icon="help-circle"
          icon-size="is-medium"
          trigger-class="has-text-link"
          contexto="auction.recursos"
          :feature-ctx="ctxTourRecursos()"
          scope="form-razoes"
          @selecionar="reabrirTutorialRecurso"
        />
      </div>
      <form @submit.prevent="salvarDados">
        <ManifestacaoFormLayout>
          <b-field grouped class="column-direction-touch">
            <b-field
              expanded
              label="Nome"
              :type="campoInvalido('nome') ? 'is-danger' : ''"
              :message="campoInvalido('nome') ? 'Nome é um campo obrigatório' : ''"
            >
              <b-input :disabled="logged" v-model="$v.dados.nome.$model" />
            </b-field>
            <b-field
              v-if="logged"
              label="CNPJ"
              :type="campoInvalido('cnpj') ? 'is-danger' : ''"
              :message="
                campoInvalido('cnpj') ? 'CNPJ é um campo obrigatório. Insira um número válido' : ''
              "
            >
              <b-input
                :disabled="logged"
                maxlength="18"
                :has-counter="false"
                v-mascara:cnpj
                v-model="$v.dados.cnpj.$model"
              />
            </b-field>
            <b-field
              expanded
              label="E-mail"
              :type="campoInvalido('email') ? 'is-danger' : ''"
              :message="campoInvalido('email') ? 'Insira um e-mail válido' : ''"
            >
              <b-input
                :disabled="logged"
                v-model="$v.dados.email.$model"
                @input="dados.email = dados.email.toLowerCase()"
              />
            </b-field>
          </b-field>
          <b-field grouped class="column-direction-touch">
            <b-field
              data-tour="recursos-form-razoes-assunto"
              expanded
              label="Assunto"
              :type="campoInvalido('assunto') ? 'is-danger' : ''"
              :message="campoInvalido('assunto') ? 'Assunto é um campo obrigatório' : ''"
            >
              <b-input
                custom-class="uppercase"
                v-model="$v.dados.assunto.$model"
                @input="valor => converterMaiusculo('assunto', valor)"
              />
            </b-field>
          </b-field>
          <b-field
            data-tour="recursos-form-razoes-mensagem"
            class="manifestacao-campo-textarea"
            label="Razões"
            :type="campoInvalido('mensagem') ? 'is-danger' : ''"
            :message="campoInvalido('mensagem') ? 'Informe as razões para enviar o recurso' : ''"
          >
            <b-input type="textarea" v-model="$v.dados.mensagem.$model" />
          </b-field>

          <template #upload>
            <AppUploadPanel
              data-tour="recursos-form-razoes-upload"
              class="column manifestacao-form-upload"
              v-model="arquivos"
            />
          </template>

          <template #actions>
            <button
              type="submit"
              data-tour="recursos-enviar-razoes"
              class="button is-primary send-button"
              :class="{ ' is-loading': loadingRazoes }"
            >
              Enviar Recurso
            </button>
          </template>
        </ManifestacaoFormLayout>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { email, required, requiredIf } from 'vuelidate/lib/validators';

import campoMixin from '@/mixins/formulario';
import featureTourMixin from '@/mixins/featureTour';
import { isTourActive } from '@/feature-tours';

import AppJustification from '@/components/AppJustification';
import AppMensagem from '@/components/AppMensagem';
import AppUploadPanel from '@/components/AppUploadPanel';
import FeatureTourHelp from '@/components/FeatureTourHelp';
import ManifestacaoAnexosLista from '@/components/ManifestacaoAnexosLista';
import ManifestacaoMensagemTexto from '@/components/ManifestacaoMensagemTexto';
import ManifestacaoFormLayout from '@/components/ManifestacaoFormLayout';
import ManifestacaoSituacaoBadge from '@/components/ManifestacaoSituacaoBadge';
import buildManifestacaoFormData from '@/utils/manifestacaoFormData';
import { getManifestacaoErrorMessage, chipManifestacaoRecurso } from '@/utils/manifestacaoError';
import { OPCOES_DESFECHO_CONSIDERACAO } from '@/utils/recursosConstants';
import { classeLinhaManifestacaoExpandida } from '@/utils/manifestacaoListagem';

import { verificarPregoeiro, funcoes } from '@/utils/enumerados';
import { calcularAcoesRecurso } from '@/utils/businessDays';

export default {
  name: 'PregaoRecursos',
  mixins: [campoMixin, featureTourMixin],
  components: {
    AppMensagem,
    AppUploadPanel,
    FeatureTourHelp,
    ManifestacaoAnexosLista,
    ManifestacaoMensagemTexto,
    ManifestacaoFormLayout,
    ManifestacaoSituacaoBadge,
  },
  data() {
    const opcoesStatus = OPCOES_DESFECHO_CONSIDERACAO;
    const opcoesJulgamentoAutoridade = [
      { id: 'ADMISSIVEL', nome: 'Admissível' },
      { id: 'INADMISSIVEL', nome: 'Inadmissível' },
    ];
    const dados = {
      nome: '',
      cnpj: null,
      email: '',
      assunto: '',
      mensagem: '',
    };
    const resposta = {
      justificativa: [],
      desfecho: [],
    };
    const julgamentoAutoridade = {
      justificativa: [],
      desfecho: [],
    };

    return {
      arquivos: [],
      arquivosResposta: {},
      arquivosContrarrazao: {},
      arquivosJulgamentoAutoridade: {},
      arquivosEdicao: {},
      anexosSalvosEdicao: {},
      arquivosEdicaoContrarrazao: {},
      anexosSalvosEdicaoContrarrazao: {},
      edicoesContrarrazao: {},
      contrarrazoesEmEdicao: {},
      contrarrazoes: {},
      edicoes: {},
      recursosEmEdicao: {},
      dados,
      resposta,
      julgamentoAutoridade,
      opcoesStatus,
      opcoesJulgamentoAutoridade,
      loadingRazoes: false,
      loadingResposta: {},
      loadingContrarrazao: {},
      loadingJulgamentoAutoridade: {},
      loadingEdicao: {},
      loadingEdicaoContrarrazao: {},
      loadingExclusao: {},
      loadingExclusaoContrarrazao: {},
      defaultOpenedDetails: [],
      exclusaoPendente: null,
      modalJustificativaExclusao: null,
    };
  },
  computed: {
    ...mapState('companies', ['company']),
    ...mapGetters({
      funcao: 'getFunction',
      podeApresentarRazoes: 'podeApresentarRazoes',
      elegibilidadeRazoes: 'obterElegibilidadeRazoes',
      recursos: 'obterOfertaCompraRecursos',
      logged: 'getLogged',
      ofertaCompra: 'obterOfertaCompra',
      prazos: 'obterOfertaCompraPrazos',
      prazosRecursaisDefinidos: 'prazosRecursaisDefinidos',
      janelaRecursalVigente: 'janelaRecursalVigente',
      prazosRecursais: 'obterPrazosRecursais',
    }),
    exibirTabela() {
      return this.recursos.length;
    },
    situacao() {
      return this.ofertaCompra.situacao.id;
    },
    pregoeiro() {
      return this.logged && verificarPregoeiro(this.funcao);
    },
    licitante() {
      return this.funcao === funcoes.LICITANTE;
    },
    autoridade() {
      return this.funcao === funcoes.AUTORIDADE;
    },
    papelRecurso() {
      if (this.pregoeiro) return 'pregoeiro';
      if (this.autoridade) return 'autoridade';
      return 'licitante';
    },
    podeRecursar() {
      const temPrazoInterposicao = this.prazos.some(prazo => prazo.prazo_id === 12);
      return (
        temPrazoInterposicao &&
        this.situacao === 10 &&
        this.licitante &&
        this.prazosRecursaisDefinidos
      );
    },
    licitanteJaEnviouRecurso() {
      if (this.elegibilidadeRazoes.recursoJaEnviado) return true;
      if (!this.company?.id) return false;

      const inicioCiclo = this.prazosRecursais?.linhaDoTempo?.d0;
      if (!inicioCiclo) return false;

      const inicio = new Date(inicioCiclo).getTime();
      return this.recursos.some(
        recurso =>
          Number(recurso.empresaId) === Number(this.company.id) &&
          recurso.criado &&
          new Date(recurso.criado).getTime() >= inicio,
      );
    },
    podeApresentarRazoesForm() {
      return (
        !this.company.buyer &&
        this.podeRecursar &&
        this.podeApresentarRazoes &&
        !this.licitanteJaEnviouRecurso
      );
    },
    exibirAvisoPreclusaoConsumativa() {
      return !this.company.buyer && this.podeRecursar && this.elegibilidadeRazoes.recursoExcluido;
    },
    exibirAvisoRecursoJaEnviado() {
      return (
        !this.company.buyer &&
        this.podeRecursar &&
        !this.exibirAvisoPreclusaoConsumativa &&
        (this.elegibilidadeRazoes.recursoJaEnviado || this.licitanteJaEnviouRecurso)
      );
    },
    exibirAvisoSemIntencao() {
      return (
        !this.company.buyer &&
        this.podeRecursar &&
        !this.exibirAvisoPreclusaoConsumativa &&
        !this.exibirAvisoRecursoJaEnviado &&
        !this.elegibilidadeRazoes.podeApresentarRazoes
      );
    },
    exibirAvisoAguardandoAberturaPrazos() {
      const temPrazoInterposicao = this.prazos.some(prazo => prazo.prazo_id === 12);

      return (
        !this.company.buyer &&
        this.licitante &&
        this.situacao === 10 &&
        temPrazoInterposicao &&
        this.elegibilidadeRazoes.podeApresentarRazoes &&
        !this.prazosRecursaisDefinidos &&
        !this.exibirAvisoPreclusaoConsumativa
      );
    },
  },
  watch: {
    company() {
      this.carregarInfoEmpresa();
    },
    situacao() {
      this.carregarElegibilidade();
      this.agendarToursRecursos();
    },
    licitante() {
      this.carregarElegibilidade();
      this.agendarToursRecursos();
    },
    prazos: {
      handler() {
        this.carregarElegibilidade();
        this.agendarToursRecursos();
      },
      deep: true,
    },
    'ofertaCompra.id': {
      handler() {
        this.carregarElegibilidade();
      },
    },
    recursos: {
      handler() {
        this.agendarToursRecursos();
      },
      deep: true,
    },
    podeApresentarRazoesForm() {
      this.agendarToursRecursos();
    },
    prazosRecursaisDefinidos() {
      this.carregarElegibilidade();
      this.agendarToursRecursos();
    },
  },
  validations: {
    dados: {
      nome: { required },
      cnpj: {
        required: requiredIf(function validarcnpj() {
          return this.company.cnpj;
        }),
      },
      email: { email, required },
      assunto: { required },
      mensagem: { required },
    },
    resposta: {
      justificativa: { required },
      desfecho: { required },
    },
    julgamentoAutoridade: {
      justificativa: { required },
      desfecho: { required },
    },
  },
  methods: {
    ...mapActions([
      'salvarOfertaCompraRecurso',
      'editarOfertaCompraRecurso',
      'responderOfertaCompraRecurso',
      'julgarRecursoAutoridade',
      'salvarContrarrazao',
      'editarContrarrazaoRecurso',
      'excluirRazoesRecurso',
      'excluirContrarrazaoRecurso',
      'buscarElegibilidadeRazoes',
      'buscarPrazosRecursais',
    ]),
    chipManifestacao(tipo) {
      return chipManifestacaoRecurso(tipo);
    },
    acoesRecurso(recurso) {
      return calcularAcoesRecurso(recurso.status, this.prazosRecursais);
    },
    exibirNomeRemetenteManifestacao(tipo) {
      return ['CONTRARAZOES', 'CONSIDERACAO', 'JULGAMENTO'].includes(tipo);
    },
    obterDataEdicaoManifestacao(manifestacao) {
      if (!['RAZOES', 'CONTRARAZOES'].includes(manifestacao?.tipo)) return null;

      const { criado, atualizado } = manifestacao;
      if (!criado || !atualizado) return null;

      return atualizado.getTime() > criado.getTime() ? atualizado : null;
    },
    obterManifestacaoRazoes(recurso) {
      return (recurso?.manifestacoes || []).find(manifestacao => manifestacao.tipo === 'RAZOES');
    },
    nomeEmpresaRecurso(recurso) {
      return this.obterManifestacaoRazoes(recurso)?.nome || '';
    },
    classeLinhaManifestacao(row) {
      return classeLinhaManifestacaoExpandida(row, this.defaultOpenedDetails);
    },
    recursoProprio(recurso) {
      return (
        this.licitante &&
        this.company?.id != null &&
        Number(recurso.empresaId) === Number(this.company.id)
      );
    },
    emFaseRecursal() {
      return this.situacao === 10;
    },
    podeEditarRecurso(recurso) {
      if (!this.emFaseRecursal() || !this.recursoProprio(recurso) || recurso.status !== 'CRIADO') {
        return false;
      }

      return Boolean(this.acoesRecurso(recurso).podeEditarRazoes);
    },
    podeExcluirRecurso(recurso) {
      if (!this.emFaseRecursal() || !this.recursoProprio(recurso) || recurso.status !== 'CRIADO') {
        return false;
      }

      return Boolean(this.acoesRecurso(recurso).podeExcluirRazoes);
    },
    podeExibirEditarManifestacao(recurso, manifestacao) {
      return manifestacao.tipo === 'RAZOES' && this.podeEditarRecurso(recurso);
    },
    podeExibirExcluirManifestacao(recurso, manifestacao) {
      return manifestacao.tipo === 'RAZOES' && this.podeExcluirRecurso(recurso);
    },
    podeExibirEditarContrarrazao(recurso, manifestacao) {
      if (!this.emFaseRecursal()) return false;
      if (manifestacao.tipo !== 'CONTRARAZOES') return false;
      if (!this.licitante || this.company?.buyer) return false;
      if (this.company?.id == null) return false;
      if (Number(manifestacao.empresaId) !== Number(this.company.id)) return false;

      return Boolean(this.acoesRecurso(recurso).podeEditarContrarrazoes);
    },
    podeExibirExcluirContrarrazao(recurso, manifestacao) {
      if (!this.emFaseRecursal()) return false;
      if (manifestacao.tipo !== 'CONTRARAZOES') return false;
      if (!this.licitante || this.company?.buyer) return false;
      if (this.company?.id == null) return false;
      if (Number(manifestacao.empresaId) !== Number(this.company.id)) return false;

      return Boolean(this.acoesRecurso(recurso).podeExcluirContrarrazoes);
    },
    contrarrazaoEmEdicao(manifestacaoId) {
      return Boolean(this.contrarrazoesEmEdicao[manifestacaoId]);
    },
    recursoEmEdicao(recursoId) {
      return Boolean(this.recursosEmEdicao[recursoId]);
    },
    obterEdicaoCampo(recursoId, campo) {
      return this.edicoes[recursoId]?.[campo] ?? '';
    },
    definirEdicaoCampo(recursoId, campo, valor) {
      const edicao = this.edicoes[recursoId] || {};
      this.$set(this.edicoes, recursoId, { ...edicao, [campo]: valor });
    },
    definirArquivosEdicao(recursoId, arquivos) {
      this.$set(this.arquivosEdicao, recursoId, arquivos);
    },
    definirAnexosSalvosEdicao(recursoId, anexos) {
      this.$set(this.anexosSalvosEdicao, recursoId, anexos);
    },
    edicaoInvalida(recursoId, campo) {
      const edicao = this.edicoes[recursoId];
      if (!edicao?.exibirErros) return false;
      if (campo === 'assunto') return !edicao.assunto?.trim();
      if (campo === 'mensagem') return !edicao.mensagem?.trim();
      return false;
    },
    iniciarEdicaoRecurso(recurso) {
      if (!this.podeEditarRecurso(recurso)) return;

      if (!this.defaultOpenedDetails.includes(recurso.id)) {
        this.defaultOpenedDetails = [...this.defaultOpenedDetails, recurso.id];
      }

      const razoes = (recurso.manifestacoes || []).find(
        manifestacao => manifestacao.tipo === 'RAZOES',
      );

      this.$set(this.edicoes, recurso.id, {
        nome: razoes?.nome || this.company?.socialDenomination || '',
        cnpj: razoes?.cnpj || this.company?.cnpj || null,
        email: razoes?.email || this.company?.email || '',
        assunto: recurso.assunto || '',
        mensagem: razoes?.descricao || '',
        exibirErros: false,
        anexosOriginaisIds: (razoes?.anexos || []).map(anexo => anexo.id),
      });
      this.$set(
        this.anexosSalvosEdicao,
        recurso.id,
        (razoes?.anexos || []).map(anexo => ({ ...anexo })),
      );
      this.$set(this.arquivosEdicao, recurso.id, []);
      this.$set(this.recursosEmEdicao, recurso.id, true);
    },
    finalizarEdicaoRecurso(recursoId) {
      this.$delete(this.recursosEmEdicao, recursoId);
      this.$delete(this.edicoes, recursoId);
      this.$delete(this.arquivosEdicao, recursoId);
      this.$delete(this.anexosSalvosEdicao, recursoId);
      this.$delete(this.loadingEdicao, recursoId);
    },
    cancelarEdicaoRecurso(recursoId) {
      this.finalizarEdicaoRecurso(recursoId);
    },
    obterAnexosRemovidosIds(recursoId) {
      const edicao = this.edicoes[recursoId];
      const anexosSalvos = this.anexosSalvosEdicao[recursoId] || [];
      const anexosOriginaisIds = edicao?.anexosOriginaisIds || [];

      return anexosOriginaisIds.filter(
        id => !anexosSalvos.some(anexo => Number(anexo.id) === Number(id)),
      );
    },
    async confirmarEdicaoRecurso(recurso) {
      if (!this.podeEditarRecurso(recurso)) {
        this.$alerta('Ações de recurso permitidas apenas na fase recursal', 'is-danger');
        this.finalizarEdicaoRecurso(recurso.id);
        return;
      }

      const edicao = this.edicoes[recurso.id];
      if (!edicao?.assunto?.trim() || !edicao?.mensagem?.trim()) {
        this.$set(this.edicoes, recurso.id, { ...edicao, exibirErros: true });
        return;
      }

      this.$set(this.loadingEdicao, recurso.id, true);
      try {
        const dados = {
          nome: edicao.nome,
          cnpj: edicao.cnpj,
          email: edicao.email,
          assunto: edicao.assunto,
          mensagem: edicao.mensagem,
        };
        const removerAnexosIds = this.obterAnexosRemovidosIds(recurso.id);
        await this.editarOfertaCompraRecurso({
          id: recurso.id,
          dados: buildManifestacaoFormData(dados, this.arquivosEdicao[recurso.id] || [], {
            removerAnexosIds,
          }),
        });
        this.$alerta('Alterações confirmadas', 'is-success');
        this.finalizarEdicaoRecurso(recurso.id);
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingEdicao, recurso.id);
    },
    obterEdicaoContrarrazaoCampo(manifestacaoId, campo) {
      return this.edicoesContrarrazao[manifestacaoId]?.[campo] ?? '';
    },
    definirEdicaoContrarrazaoCampo(manifestacaoId, campo, valor) {
      const edicao = this.edicoesContrarrazao[manifestacaoId] || {};
      this.$set(this.edicoesContrarrazao, manifestacaoId, { ...edicao, [campo]: valor });
    },
    definirArquivosEdicaoContrarrazao(manifestacaoId, arquivos) {
      this.$set(this.arquivosEdicaoContrarrazao, manifestacaoId, arquivos);
    },
    definirAnexosSalvosEdicaoContrarrazao(manifestacaoId, anexos) {
      this.$set(this.anexosSalvosEdicaoContrarrazao, manifestacaoId, anexos);
    },
    edicaoContrarrazaoInvalida(manifestacaoId, campo) {
      const edicao = this.edicoesContrarrazao[manifestacaoId];
      if (!edicao?.exibirErros) return false;
      if (campo === 'mensagem') return !edicao.mensagem?.trim();
      return false;
    },
    iniciarEdicaoContrarrazao(recurso, manifestacao) {
      if (!this.podeExibirEditarContrarrazao(recurso, manifestacao)) return;

      if (!this.defaultOpenedDetails.includes(recurso.id)) {
        this.defaultOpenedDetails = [...this.defaultOpenedDetails, recurso.id];
      }

      this.$set(this.edicoesContrarrazao, manifestacao.id, {
        nome: manifestacao.nome || this.company?.socialDenomination || '',
        cnpj: manifestacao.cnpj || this.company?.cnpj || null,
        email: manifestacao.email || this.company?.email || '',
        mensagem: manifestacao.descricao || '',
        exibirErros: false,
        anexosOriginaisIds: (manifestacao.anexos || []).map(anexo => anexo.id),
      });
      this.$set(
        this.anexosSalvosEdicaoContrarrazao,
        manifestacao.id,
        (manifestacao.anexos || []).map(anexo => ({ ...anexo })),
      );
      this.$set(this.arquivosEdicaoContrarrazao, manifestacao.id, []);
      this.$set(this.contrarrazoesEmEdicao, manifestacao.id, true);
    },
    finalizarEdicaoContrarrazao(manifestacaoId) {
      this.$delete(this.contrarrazoesEmEdicao, manifestacaoId);
      this.$delete(this.edicoesContrarrazao, manifestacaoId);
      this.$delete(this.arquivosEdicaoContrarrazao, manifestacaoId);
      this.$delete(this.anexosSalvosEdicaoContrarrazao, manifestacaoId);
      this.$delete(this.loadingEdicaoContrarrazao, manifestacaoId);
    },
    cancelarEdicaoContrarrazao(manifestacaoId) {
      this.finalizarEdicaoContrarrazao(manifestacaoId);
    },
    obterAnexosRemovidosContrarrazaoIds(manifestacaoId) {
      const edicao = this.edicoesContrarrazao[manifestacaoId];
      const anexosSalvos = this.anexosSalvosEdicaoContrarrazao[manifestacaoId] || [];
      const anexosOriginaisIds = edicao?.anexosOriginaisIds || [];

      return anexosOriginaisIds.filter(
        id => !anexosSalvos.some(anexo => Number(anexo.id) === Number(id)),
      );
    },
    async confirmarEdicaoContrarrazao(recurso, manifestacao) {
      if (!this.podeExibirEditarContrarrazao(recurso, manifestacao)) {
        this.$alerta('Ações de recurso permitidas apenas na fase recursal', 'is-danger');
        this.finalizarEdicaoContrarrazao(manifestacao.id);
        return;
      }

      const edicao = this.edicoesContrarrazao[manifestacao.id];
      if (!edicao?.mensagem?.trim()) {
        this.$set(this.edicoesContrarrazao, manifestacao.id, {
          ...edicao,
          exibirErros: true,
        });
        return;
      }

      this.$set(this.loadingEdicaoContrarrazao, manifestacao.id, true);
      try {
        const dados = {
          nome: edicao.nome,
          cnpj: edicao.cnpj,
          email: edicao.email,
          descricao: edicao.mensagem,
        };
        const removerAnexosIds = this.obterAnexosRemovidosContrarrazaoIds(manifestacao.id);
        await this.editarContrarrazaoRecurso({
          recursoId: recurso.id,
          dados: buildManifestacaoFormData(
            dados,
            this.arquivosEdicaoContrarrazao[manifestacao.id] || [],
            { removerAnexosIds },
          ),
        });
        this.$alerta('Alterações confirmadas', 'is-success');
        this.finalizarEdicaoContrarrazao(manifestacao.id);
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingEdicaoContrarrazao, manifestacao.id);
    },
    exibirCamposConsideracao(recurso) {
      return Boolean(
        this.emFaseRecursal() && this.pregoeiro && this.acoesRecurso(recurso).podeConsiderar,
      );
    },
    exibirJulgamentoAutoridade(recurso) {
      return Boolean(
        this.emFaseRecursal() && this.autoridade && this.acoesRecurso(recurso).podeJulgarAutoridade,
      );
    },
    definirArquivosJulgamentoAutoridade(recursoId, arquivos) {
      this.$set(this.arquivosJulgamentoAutoridade, recursoId, arquivos);
    },
    definirArquivosResposta(recursoId, arquivos) {
      this.$set(this.arquivosResposta, recursoId, arquivos);
    },
    definirArquivosContrarrazao(recursoId, arquivos) {
      this.$set(this.arquivosContrarrazao, recursoId, arquivos);
    },
    obterContrarrazaoTexto(recursoId) {
      return this.contrarrazoes[recursoId]?.descricao || '';
    },
    definirContrarrazaoTexto(recursoId, valor) {
      this.$set(this.contrarrazoes, recursoId, { descricao: valor, exibirErro: false });
    },
    contrarrazaoInvalida(recursoId) {
      const estado = this.contrarrazoes[recursoId];
      return Boolean(estado?.exibirErro && !estado?.descricao?.trim());
    },
    contrarrazaoJaEnviada(recurso) {
      if (!this.company?.id) return false;

      const empresasRegistradas = recurso?.empresasContrarrazaoRegistradas || [];
      if (empresasRegistradas.some(id => Number(id) === Number(this.company.id))) {
        return true;
      }

      if (!Array.isArray(recurso?.manifestacoes)) return false;
      return recurso.manifestacoes.some(
        manifestacao =>
          manifestacao.tipo === 'CONTRARAZOES' &&
          Number(manifestacao.empresaId) === Number(this.company.id),
      );
    },
    textoIntroExclusao(tipo) {
      if (tipo === 'contrarrazao') {
        return (
          'A contrarrazão será <strong>excluída definitivamente</strong>, não será possível recuperá-la ' +
          'nem enviar uma nova contrarrazão. Deseja confirmar a exclusão definitiva?'
        );
      }

      return (
        'O recurso será <strong>excluído definitivamente</strong>, não será possível recuperá-lo ' +
        'nem enviar um novo recurso. Deseja confirmar a exclusão definitiva?'
      );
    },
    fecharModalJustificativaExclusao() {
      if (this.modalJustificativaExclusao) {
        this.modalJustificativaExclusao.close();
        this.modalJustificativaExclusao = null;
      }
    },
    abrirModalJustificativaExclusao(tipo, recurso, manifestacao = null) {
      this.fecharModalJustificativaExclusao();
      this.exclusaoPendente = { tipo, recurso, manifestacao };

      this.modalJustificativaExclusao = this.$buefy.modal.open({
        parent: this,
        component: AppJustification,
        hasModalCard: true,
        trapFocus: true,
        props: {
          displaySuccessButton: false,
          failText: 'Confirmar',
          skipDoubleConfirm: true,
          titleText: tipo === 'contrarrazao' ? 'Excluir Contrarrazão' : 'Excluir Recurso',
          placeholderText: 'Justificativa',
          introText: this.textoIntroExclusao(tipo),
        },
        events: {
          justificate: this.enviarJustificativaExclusao,
        },
        onCancel: () => {
          this.exclusaoPendente = null;
          this.modalJustificativaExclusao = null;
        },
      });
    },
    confirmarExclusaoRazoes(recurso) {
      if (!this.podeExcluirRecurso(recurso)) return;
      this.abrirModalJustificativaExclusao('razoes', recurso);
    },
    confirmarExclusaoContrarrazao(recurso, manifestacao) {
      if (!this.podeExibirExcluirContrarrazao(recurso, manifestacao)) return;
      this.abrirModalJustificativaExclusao('contrarrazao', recurso, manifestacao);
    },
    enviarJustificativaExclusao({ justification }) {
      const justificativa = String(justification || '').trim();
      if (!justificativa) {
        this.$alerta('Informe a justificativa da exclusão', 'is-warning');
        return;
      }

      const pendente = this.exclusaoPendente;
      this.exclusaoPendente = null;
      this.fecharModalJustificativaExclusao();

      if (!pendente) return;

      if (pendente.tipo === 'contrarrazao') {
        this.executarExclusaoContrarrazao(pendente.recurso, pendente.manifestacao, justificativa);
        return;
      }

      this.executarExclusaoRazoes(pendente.recurso, justificativa);
    },
    async executarExclusaoRazoes(recurso, justificativa) {
      if (this.recursoEmEdicao(recurso.id)) {
        this.cancelarEdicaoRecurso(recurso.id);
      }

      this.$set(this.loadingExclusao, recurso.id, true);
      try {
        await this.excluirRazoesRecurso({ recursoId: recurso.id, justificativa });
        this.$alerta('Razões excluídas com sucesso', 'is-success');
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingExclusao, recurso.id);
    },
    async executarExclusaoContrarrazao(recurso, manifestacao, justificativa) {
      if (this.contrarrazaoEmEdicao(manifestacao.id)) {
        this.cancelarEdicaoContrarrazao(manifestacao.id);
      }

      this.$set(this.loadingExclusaoContrarrazao, manifestacao.id, true);
      try {
        await this.excluirContrarrazaoRecurso({ recursoId: recurso.id, justificativa });
        this.$alerta('Contrarrazões excluídas com sucesso', 'is-success');
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingExclusaoContrarrazao, manifestacao.id);
    },
    podeContrarrazoar(recurso) {
      return Boolean(
        this.emFaseRecursal() &&
          !this.company.buyer &&
          this.acoesRecurso(recurso).podeContrarrazoar &&
          this.licitante &&
          recurso.empresaId !== this.company.id &&
          !this.contrarrazaoJaEnviada(recurso),
      );
    },
    async salvarContrarrazaoRecurso(recurso) {
      if (!this.podeContrarrazoar(recurso)) {
        this.$alerta('Ações de recurso permitidas apenas na fase recursal', 'is-danger');
        return;
      }

      const descricao = this.obterContrarrazaoTexto(recurso.id).trim();
      if (!descricao) {
        this.$set(this.contrarrazoes, recurso.id, { descricao, exibirErro: true });
        return;
      }
      this.$set(this.loadingContrarrazao, recurso.id, true);
      try {
        const dados = {
          nome: this.company.socialDenomination,
          cnpj: this.company.cnpj,
          email: this.company.email,
          descricao,
        };
        await this.salvarContrarrazao({
          recursoId: recurso.id,
          dados: buildManifestacaoFormData(dados, this.arquivosContrarrazao[recurso.id] || []),
        });
        this.$alerta('Contrarrazões enviadas', 'is-success');
        this.$delete(this.contrarrazoes, recurso.id);
        this.$delete(this.arquivosContrarrazao, recurso.id);
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingContrarrazao, recurso.id);
    },
    carregarInfoEmpresa() {
      if (this.company) {
        this.dados.nome = this.company.socialDenomination;
        this.dados.cnpj = this.company.cnpj;
        this.dados.email = this.company.email;
      }
    },
    async carregarElegibilidade() {
      if (!this.licitante || this.situacao !== 10 || !this.ofertaCompra?.id) {
        return;
      }
      try {
        await this.buscarElegibilidadeRazoes(this.ofertaCompra.id);
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
    },
    async salvarDados() {
      if (!this.podeApresentarRazoesForm) {
        return;
      }
      if (this.validar('dados')) {
        this.loadingRazoes = true;
        try {
          const formData = buildManifestacaoFormData(this.dados, this.arquivos);
          await this.salvarOfertaCompraRecurso(formData);
          this.$alerta('Dados salvos', 'is-success');
          this.arquivos = [];
          this.limparCampos();
          this.$v.dados.$reset();
          if (this.company) this.carregarInfoEmpresa();
        } catch (error) {
          this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
        }
        this.loadingRazoes = false;
      }
    },
    async salvarJustificativa(recurso, indice) {
      if (!this.exibirCamposConsideracao(recurso)) {
        this.$alerta('Ações de recurso permitidas apenas na fase recursal', 'is-danger');
        return;
      }
      if (!this.validar('resposta')) return;

      const proceed = await this.$confirmacao({
        message: 'Não será possível alterar a consideração posteriormente. Deseja continuar?',
        cancelText: 'Cancelar',
        confirmText: 'Continuar',
      });
      if (!proceed) return;

      this.$set(this.loadingResposta, recurso.id, true);
      try {
        const dados = {
          desfecho: this.resposta.desfecho[indice],
          descricao: this.resposta.justificativa[indice],
        };
        await this.responderOfertaCompraRecurso({
          id: recurso.id,
          dados: buildManifestacaoFormData(dados, this.arquivosResposta[recurso.id] || []),
        });
        this.$alerta('Respondido', 'is-success');
        this.$v.resposta.$reset();
        this.$delete(this.arquivosResposta, recurso.id);
        this.limparCamposPregoeiro(indice);
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingResposta, recurso.id);
    },
    limparCamposPregoeiro(indice) {
      this.resposta.desfecho.splice(indice, 1);
      this.resposta.justificativa.splice(indice, 1);
    },
    async salvarJulgamentoAutoridade(recurso, indice) {
      if (!this.exibirJulgamentoAutoridade(recurso)) {
        this.$alerta('Ações de recurso permitidas apenas na fase recursal', 'is-danger');
        return;
      }
      if (!this.validar('julgamentoAutoridade')) return;

      const proceed = await this.$confirmacao({
        message: 'Não será possível alterar o julgamento posteriormente. Deseja continuar?',
        cancelText: 'Cancelar',
        confirmText: 'Continuar',
      });
      if (!proceed) return;

      this.$set(this.loadingJulgamentoAutoridade, recurso.id, true);
      try {
        const dados = {
          desfecho: this.julgamentoAutoridade.desfecho[indice],
          descricao: this.julgamentoAutoridade.justificativa[indice],
        };
        await this.julgarRecursoAutoridade({
          id: recurso.id,
          dados: buildManifestacaoFormData(
            dados,
            this.arquivosJulgamentoAutoridade[recurso.id] || [],
          ),
        });
        this.$alerta('Julgamento registrado', 'is-success');
        this.$v.julgamentoAutoridade.$reset();
        this.$delete(this.arquivosJulgamentoAutoridade, recurso.id);
        this.julgamentoAutoridade.desfecho.splice(indice, 1);
        this.julgamentoAutoridade.justificativa.splice(indice, 1);
      } catch (error) {
        this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
      }
      this.$delete(this.loadingJulgamentoAutoridade, recurso.id);
    },
    limparCampos() {
      this.dados.assunto = '';
      this.dados.mensagem = '';
    },
    garantirDetalheAberto(recursoId) {
      if (!recursoId) return;
      if (!this.defaultOpenedDetails.includes(recursoId)) {
        this.defaultOpenedDetails = [...this.defaultOpenedDetails, recursoId];
      }
    },
    agendarToursRecursos() {
      this.$nextTick(() => {
        this.tentarIniciarToursRecursos();
      });
    },
    ctxTourRecursos(extra = {}) {
      return {
        logged: this.logged,
        formVisible: true,
        acoesVisiveis: this.temAcoesEditarExcluirVisiveis(),
        hasRazoes: this.temRazoesCadastradas(),
        hasContrarrazoes: this.temContrarrazoesCadastradas(),
        podeApresentarRazoes: this.podeApresentarRazoesForm,
        podeContrarrazoar: this.recursos.some(item => this.podeContrarrazoar(item)),
        podeConsiderar: this.recursos.some(item => this.exibirCamposConsideracao(item)),
        podeJulgar: this.recursos.some(item => this.exibirJulgamentoAutoridade(item)),
        ...extra,
      };
    },
    preparesTourRecursos() {
      return {
        'recursos-form-contrarrazoes': async () => {
          const recurso = this.recursos.find(item => this.podeContrarrazoar(item));
          if (recurso) {
            this.garantirDetalheAberto(recurso.id);
            await this.$nextTick();
          }
        },
        'recursos-form-consideracao': async () => {
          const recurso = this.recursos.find(item => this.exibirCamposConsideracao(item));
          if (recurso) {
            this.garantirDetalheAberto(recurso.id);
            await this.$nextTick();
          }
        },
        'recursos-form-julgamento': async () => {
          const recurso = this.recursos.find(item => this.exibirJulgamentoAutoridade(item));
          if (recurso) {
            this.garantirDetalheAberto(recurso.id);
            await this.$nextTick();
          }
        },
        'recursos-editar-excluir': async () => {
          await this.abrirDetalheComAcoesEditarExcluir();
        },
        'recursos-editar-excluir-hints': async () => {
          await this.abrirDetalheComAcoesEditarExcluir();
        },
      };
    },
    async abrirDetalheComAcoesEditarExcluir() {
      const recurso = this.recursos.find(item =>
        (item.manifestacoes || []).some(
          manifestacao =>
            this.podeExibirEditarManifestacao(item, manifestacao) ||
            this.podeExibirExcluirManifestacao(item, manifestacao) ||
            this.podeExibirEditarContrarrazao(item, manifestacao) ||
            this.podeExibirExcluirContrarrazao(item, manifestacao),
        ),
      );
      if (!recurso) return;

      this.garantirDetalheAberto(recurso.id);
      await this.$nextTick();
      await this.$nextTick();

      const acaoVisivel = () =>
        Boolean(
          document.querySelector('[data-tour="recursos-editar-manifestacao"]') ||
            document.querySelector('[data-tour="recursos-excluir-manifestacao"]'),
        );
      // b-table pode atrasar o slot de detalhe além de um nextTick.
      for (let tentativa = 0; tentativa < 8 && !acaoVisivel(); tentativa += 1) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise(resolve => setTimeout(resolve, 40));
      }
    },
    async tentarIniciarToursRecursos() {
      if (!this.logged || this.situacao !== 10) return;
      if (isTourActive()) return;

      await this.rodarContextoFeatures('auction.recursos', this.ctxTourRecursos(), {
        prepares: this.preparesTourRecursos(),
      });
    },
    temRazoesCadastradas() {
      return this.recursos.some(recurso =>
        (recurso.manifestacoes || []).some(manifestacao => manifestacao.tipo === 'RAZOES'),
      );
    },
    temContrarrazoesCadastradas() {
      return this.recursos.some(recurso =>
        (recurso.manifestacoes || []).some(manifestacao => manifestacao.tipo === 'CONTRARAZOES'),
      );
    },
    temAcoesEditarExcluirVisiveis() {
      return this.recursos.some(item =>
        (item.manifestacoes || []).some(
          manifestacao =>
            this.podeExibirEditarManifestacao(item, manifestacao) ||
            this.podeExibirExcluirManifestacao(item, manifestacao) ||
            this.podeExibirEditarContrarrazao(item, manifestacao) ||
            this.podeExibirExcluirContrarrazao(item, manifestacao),
        ),
      );
    },
    async reabrirTutorialRecurso(tourId) {
      if (!tourId) return;
      await this.reabrirFeature(tourId, this.ctxTourRecursos(), {
        prepares: this.preparesTourRecursos(),
      });
    },
    tutorialRecursoDisponivel(tourId) {
      if (!tourId || !this.logged || this.situacao !== 10) return false;
      return this.opcoesAjudaContexto('auction.recursos', this.ctxTourRecursos()).some(
        opcao => opcao.id === tourId,
      );
    },
  },
  async created() {
    this.carregarInfoEmpresa();
    await this.carregarElegibilidade();
    if (this.ofertaCompra?.id && this.situacao === 10) {
      await this.buscarPrazosRecursais(this.ofertaCompra.id);
    }
  },
  mounted() {
    this.agendarToursRecursos();
    if (typeof IntersectionObserver !== 'undefined' && this.$el) {
      this._recursosTourObserver = new IntersectionObserver(
        entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.agendarToursRecursos();
          }
        },
        { threshold: 0.05 },
      );
      this._recursosTourObserver.observe(this.$el);
    }
  },
  beforeDestroy() {
    this.ocultarHintsAtivos();
    if (this._recursosTourObserver) {
      this._recursosTourObserver.disconnect();
      this._recursosTourObserver = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.div-paragraph {
  justify-content: center !important;
}

.mensagem {
  white-space: pre-line;
}

.manifestacao-chip.tag:not(body) {
  height: 2em;
  padding-left: 0.75em;
  padding-right: 0.75em;
  font-size: 0.95rem;
}

.manifestacao-recurso-corpo {
  margin-bottom: 0;
}

.recurso-acoes {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 0 !important;
  gap: 0;
}

.recurso-acoes .recurso-acao-btn {
  width: 2rem;
  height: 2rem;
  padding: 0;
  margin: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.recurso-acoes .recurso-acao-btn:not(:first-child) {
  margin-left: -1px !important;
}

.titulo-form {
  margin-top: 2rem;
}

.recurso-form-titulo {
  padding-bottom: 0.65rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #dbdbdb;
}

.recurso-form-titulo.titulo-form {
  margin-top: 2rem;
}

.recurso-form-tour-help ::v-deep .feature-tour-help__trigger {
  color: #3273dc;
}

.recurso-form-tour-help ::v-deep .icon {
  font-size: 1.5rem !important;
  width: 1.75rem !important;
  height: 1.75rem !important;
}

.recurso-form-tour-help ::v-deep .mdi:before,
.recurso-form-tour-help ::v-deep .icon i {
  font-size: 1.5rem !important;
}

.titulo-contrarrazao {
  margin-bottom: 0;
}

.titulo-julgamento {
  margin-bottom: 0;
}

.send-resource {
  margin-top: 1rem;
}

.send-button {
  margin-top: 0.75rem;
  padding-left: 0.75em;
  padding-right: 0.75em;
  min-width: 150px;
  width: auto;
  height: auto;
}

.manifestacao-form-botoes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

@media (max-width: 1023px) {
  .send-button {
    width: 100%;
  }
}
</style>
<style src="@/styles/manifestacao.scss" lang="scss" scoped />
